import { ChakraFlex as Flex, Icons } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import { getPageUrl } from "utils/getPageUrl";
import { trackUAClickEvent } from "utils/tracking/utils";
import { config } from "./FunnelButton.config";

export const FunnelButton = ({ type }: { type: "uploader" | "scanner" }) => {
  const translations = useTranslations();
  const language = useLanguage();
  const { destination, icon, eventLabel, textKey } = config[type];

  const IconComponent = icon;

  const trackButton = () => trackUAClickEvent("Hero", eventLabel);

  return (
    <Flex
      mt={2}
      as="a"
      bgColor="primary.200"
      p={3}
      borderRadius="md"
      fontWeight="medium"
      alignItems="center"
      href={getPageUrl(language, destination)}
      onClick={trackButton}
    >
      <IconComponent mr={3} boxSize={10} bgColor="greyscale.100" borderRadius="sm" />
      {translations(textKey)}
      <Icons.AltArrowForward boxSize={6} color="primary.500" ml="auto" />
    </Flex>
  );
};
